export const comparisonTableData = {
  header: {
    competitors: ['ADT', 'Ring'],
    titles: ['ADT', 'Ring'],
    icons: ['ADTLogo', 'Ring']
  },
  body: [
    {
      rows: [
        {
          feature:
            '24/7 professional monitoring with no long term contract and no hidden fees',
          values: [true, false, true]
        },
        {
          feature:
            'Automatic verification of alarms by monitoring agents, for priority dispatchSUP(1)',
          values: [true, true, false]
        },
        {
          feature:
            'Agents can help prevent crime before it happens using the outdoor cameraSUP(2)',
          values: [true, false, true]
        },
        {
          feature:
            'Agents can use the indoor camera to help stop crime in real timeSUP(3)',
          values: [true, false, false]
        },
        {
          feature: 'Confirm or cancel alarms via text message',
          values: [true, 'Multi-step process', false]
        }
      ],
      groupIcon: 'HeadsetPerson',
      groupName: 'Monitoring'
    },
    {
      rows: [
        {
          feature: 'Integrated privacy shutter on all indoor cameras',
          values: [true, false, false]
        },
        {
          feature:
            'Advanced motion sensor technology certified for safety intrusion-detection',
          values: [true, true, false]
        },
        {
          feature: 'Free arming and disarming from the app',
          values: [true, false, false]
        },
        {
          feature: 'App store rating as of September 2024',
          ratings: [4.8, 4.8, 4.6]
        },
        {
          feature:
            'Built in Wi-Fi and cellular connections, plus up to 24-hour battery backup in the event of outagesSUP(4)',
          values: [true, true, true]
        },
        {
          feature:
            'Easy installation options. Same advanced, whole-home protection',
          values: [true, true, true]
        },
        {
          feature: 'Smart home integrations',
          values: [true, true, true]
        },
        {
          feature: 'Smash-proof Keypad design',
          values: [true, true, true]
        },
        {
          feature: 'Designed by us with your safety in mind',
          values: [true, 'Third party cameras', true]
        }
      ],
      groupIcon: 'BaseStation',
      groupName: 'Equipment'
    },
    {
      rows: [
        {
          feature: 'Included subscription lifetime hardware warrantySUP(5)',
          values: [true, false, true]
        },
        {
          feature:
            'Discount on additional hardware for existing customersSUP(5)',
          values: [true, false, true]
        },
        {
          feature: '100% money back guarantee with free return shipping',
          values: ['60 days', 'With restrictions', '30 days']
        },
        {
          feature: 'No hidden fees or long term commitments',
          values: [true, false, true]
        },
        {
          feature: 'Customer willingness to recommendSUP(6)',
          values: ['65', '45', '63']
        },
        {
          feature: 'Referral discount program',
          values: [true, true, true]
        }
      ],
      groupIcon: 'DollarSigns',
      groupName: 'Value'
    }
  ],
  footer: [
    'SUP(1) With video verification, our agents capture evidence so you can get priority response over non-verified alarms.',
    'SUP(2) Requires an Outdoor Camera (Series 2) and a monitoring plan with SimpliSafe® Active Guard Outdoor Protection.',
    'SUP(3) Requiers a Smart Alarm Indoor Camera with select professional monitoring plans.',
    'SUP(4) Cellular backup available with a professional monitoring plan.',
    'SUP(5) Requires continuous subscription to select professional monitoring plans.',
    'SUP(6) December 2024 Competitor NPS Study.'
  ]
}
